import React, { Fragment } from "react"
import classnames from "classnames"
import styles from "./styles.css"

const ScheduleOnlineInterfaceSkeleton = () => {
  const mainSectionClasses = classnames(
    styles.mainSectionSkeleton,
    styles.whiteBackgroundSkeleton
  )

  const headerClasses = classnames(styles.header, styles.skeleton)

  const itemTableClasses = classnames(styles.skeleton)
  const itemValueClasses = classnames(styles.skeleton, styles.itemValue)

  const buttonClasses = classnames(styles.button, styles.skeleton)
  return (
    <Fragment>
      <div className={mainSectionClasses}>
        <div className={headerClasses}></div>
        <table className={styles.table}>
          <thead className={styles.tableHeader}>
            <tr>
              <th className={itemTableClasses}></th>
            </tr>
          </thead>

          <tbody className={styles.tableBody}>
            <tr>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
            </tr>
          </tbody>
        </table>

        <div className="u-flex u-flexJustifyEnd">
          <div className={buttonClasses}></div>
        </div>
      </div>
    </Fragment>
  )
}

export default ScheduleOnlineInterfaceSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/ScheduleOnlineInterfaceSkeleton/index.js